import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import Typography from '@material-ui/core/Typography';
import ButtonsForm from 'ui/form/ButtonsForm';
import SectionForm from './SectionForm';
import classNames from 'classnames';

const styles = theme => ({
    editIcon: {
        position: 'absolute',
        left: -theme.spacing(5),
    },
    showEditIcon: {
        right: -theme.spacing(5),
        left: 'auto',
    },
    previewEditable: {
        cursor: 'pointer',
        position: 'relative',
        display: 'inline-block',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    previewContent: {
        color: theme.palette.text.secondary,
    },
    previewItemLabel: {
        fontWeight: 500,
        marginRight: theme.spacing(),
    },
});

const Actions = {
    SUBMIT: 'submit',
    CANCEL: 'cancel',
    EDIT: 'edit',
};

class EditSectionForm extends React.Component {
    state = {
        edited: false,
        showProgress: false,
    };
    onAction = async action => {
        const { onSubmit, onCancel } = this.props;
        switch (action) {
            case Actions.EDIT:
                this.setEdited(true);
                break;
            case Actions.CANCEL:
                if (onCancel) {
                    await onCancel();
                }
                this.setEdited(false);
                break;
            case Actions.SUBMIT:
                this.setState({ showProgress: true });
                const result = await onSubmit();
                const isValid = typeof result === 'undefined' ? true : result;
                if (isValid) {
                    this.setEdited(false);
                }
                this.setState({ showProgress: false });
                break;
            default:
                break;
        }
    };
    setEdited(edited) {
        this.setState({ edited });
    }
    render() {
        const {
            classes,
            title,
            help,
            icon,
            half,
            children,
            canEdit = true,
        } = this.props;
        const [preview, edit] = findParts(children);
        const editable = !!edit;
        const component = React.cloneElement(
            canEdit && this.state.edited && editable ? edit : preview,
            {
                editable,
                canEdit,
                showProgress: this.state.showProgress,
                onAction: this.onAction,
                showEditIcon: preview && preview.props.showEditIcon,
            }
        );
        return (
            <div className={classes.root}>
                <SectionForm title={title} help={help} icon={icon} half={half}>
                    {component}
                </SectionForm>
            </div>
        );
    }
}

function findParts(children) {
    let preview = '';
    let form = '';
    React.Children.forEach(children, child => {
        if (child.type) {
            if (child.type === EditSectionForm.Preview) {
                preview = child;
            } else if (child.type === EditSectionForm.Form) {
                form = child;
            }
        }
    });
    return [preview, form];
}

function Preview({
    classes,
    children,
    editable,
    onAction,
    canEdit,
    showEditIcon,
}) {
    const [mouseOver, setMouseOver] = useState(false);
    const className =
        editable && canEdit ? classes.previewEditable : classes.preview;
    return (
        <div
            className={className}
            onClick={() => onAction(Actions.EDIT)}
            onMouseEnter={() => setMouseOver(true)}
            onMouseLeave={() => setMouseOver(false)}
        >
            {canEdit && editable && (showEditIcon || mouseOver) && (
                <EditIcon
                    color="disabled"
                    className={classNames({
                        [classes.editIcon]: true,
                        [classes.showEditIcon]: showEditIcon,
                    })}
                />
            )}
            <Typography component="div" className={classes.previewContent}>
                {!children || children === '' ? '(empty)' : children}
            </Typography>
        </div>
    );
}
function Form({
    classes,
    children,
    onAction,
    showProgress,
    locals = {},
    disabledNext,
}) {
    return (
        <div>
            {children}
            <div className={classes.buttons}>
                <ButtonsForm.BackButton
                    onClick={() => onAction(Actions.CANCEL)}
                >
                    {locals.cancel || 'Cancel'}
                </ButtonsForm.BackButton>
                <ButtonsForm.NextButton
                    label={locals.save || 'Save'}
                    onClick={() => onAction(Actions.SUBMIT)}
                    disabled={disabledNext}
                    loading={showProgress}
                />
            </div>
        </div>
    );
}

function PreviewItem({ classes, label, value, children }) {
    children = React.Children.toArray(children).filter(c => c);
    value = children.length ? <div>{children}</div> : value;
    return (
        <div className={classes.previewItem}>
            {label && (
                <span className={classes.previewItemLabel}>{label}:</span>
            )}
            {value}
        </div>
    );
}

EditSectionForm.Preview = withStyles(styles)(Preview);
EditSectionForm.PreviewItem = withStyles(styles)(PreviewItem);
EditSectionForm.Form = withStyles(styles)(Form);

export default withStyles(styles)(EditSectionForm);
